/**
 * kb-category-select.tsx — Chọn danh mục BÊN TRONG một kho tri thức (cây thụt lề), của MỘT loại (Tài liệu / Hỏi đáp /
 * Ảnh và video — mỗi loại một cây). '' = không xếp danh mục.
 */
import { useTranslation } from 'react-i18next'
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select'
import { useKnowledgeCategories, type KbCategoryKind } from '@/hooks/use-knowledge'
import { cn } from '@/lib/utils'
import { buildCategoryTree, flattenTree } from './kb-lib'

const NONE = '__none__'

export function KbCategorySelect({ knowledgeBaseId, kind, value, onChange, className, disabled, noneLabel }: {
  knowledgeBaseId: string | null | undefined
  /** Cây nào: danh mục Hỏi đáp / thư mục Tài liệu / nhóm Ảnh và video. */
  kind: KbCategoryKind
  value: string
  onChange: (id: string) => void
  className?: string
  disabled?: boolean
  noneLabel?: string
}) {
  const { t } = useTranslation('aiKnow')
  const { data: cats } = useKnowledgeCategories(knowledgeBaseId, { enabled: !!knowledgeBaseId, kind })
  const rows = knowledgeBaseId ? flattenTree(buildCategoryTree(cats ?? [])) : []
  return (
    <Select value={value || NONE} onValueChange={(v) => onChange(v === NONE ? '' : v)} disabled={disabled || !knowledgeBaseId}>
      <SelectTrigger className={cn('h-9', className)} aria-label={t('categorySelect.ariaLabel')}><SelectValue /></SelectTrigger>
      <SelectContent>
        <SelectItem value={NONE}>{noneLabel ?? t('categorySelect.none')}</SelectItem>
        {rows.map((c) => (
          <SelectItem key={c.id} value={c.id}>{`${'  '.repeat(c.depth)}${c.depth ? '└ ' : ''}${c.name}`}</SelectItem>
        ))}
      </SelectContent>
    </Select>
  )
}
